export default function requestNotificationPermission() {
  if ("Notification" in window) {
    if (Notification.permission !== "denied" && Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  }
}
